export default __webpack_public_path__ + "static/media/race-driver-grid.c610accf.png";